/* The two diagram tabs (v3 `.tabs` with an `.st-dot` per tab). */
.tabs {
  display: flex;
  gap: 2px;
  min-inline-size: 0;
  overflow-x: auto;
}

.tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  block-size: var(--control-height);
  padding: 0 10px;
  border: 0;
  border-radius: var(--radius-control);
  background: transparent;
  color: var(--text-muted);
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
  cursor: pointer;
}

.tab:hover {
  background: var(--state-hover);
  color: var(--text);
}

.tab:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.tab[aria-selected="true"] {
  background: var(--state-active);
  color: var(--text);
}

.dot,
.dotNone {
  inline-size: 8px;
  block-size: 8px;
  border-radius: 50%;
  background: var(--success);
}

.dotNone {
  background: transparent;
  box-shadow: inset 0 0 0 1.5px var(--border-control);
}

.srOnly {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
